export const brandCurrencyPrefixes = {
  AMTRAK: '$',
  AVAU: '$',
  AVUK: '£',
  AVCA: '$',
  AVNZ: '$',
  RAILBOOKER: '£',
  RBCA: '$',
  RBAU: '$',
  RBUS: '$',
  RBNZ: '$',
}

export const brandCurrencySuffixes = {
  AVAU: 'AUD',
  AVCA: 'CAD',
  AVNZ: 'NZD',
  RBCA: 'CAD',
  RBAU: 'AUD',
  RBNZ: 'NZD',
}

export const brandCurrencyTypes = {
  AMTRAK: 'USD',
  AVAU: 'AUD',
  AVUK: 'GBP',
  AVCA: 'CAD',
  AVNZ: 'NZD',
  RAILBOOKER: 'GBP',
  RBCA: 'CAD',
  RBAU: 'AUD',
  RBUS: 'USD',
  RBNZ: 'NZD',
}

export const clientIds = {
  AMTRAK: 'amtrak',
  AVAU: 'avau',
  AVUK: 'avuk',
  AVCA: 'avca',
  AVNZ: 'avnz',
  RAILBOOKER: 'railbookers',
  RBCA: 'rbca',
  RBAU: 'rbau',
  RBUS: 'rbus',
  RBNZ: 'rbnz',
}

export const phoneNumbers = {
  AMTRAK: '1 (800) 268-7252',
  AVAU: '1300 650 257',
  AVUK: '020 3780 2300',
  AVCA: '800-414-9007',
  RAILBOOKER: '020 3780 2222',
  RBCA: '877-579-9217',
  RBAU: '1300 938 534',
  RBUS: '1-888-829-3040',
}

export const parentBrands = {
  amtrak: 'AMTRAK',
  railbooker: 'RAILBOOKER',
}

export function isRailBookers() {
  return process.env.REACT_APP_PARENT_BRAND_CODE === parentBrands.railbooker
}
